import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import VBox from '../../components/layout/VBox';
import HBox from '../../components/layout/HBox';
import Cabecalho from '../../components/tipografia/Cabecalho';
import Texto from '../../components/tipografia/Texto';
import Botao from '../../components/Botao';
import styles from './page.module.css';

const BG_URL = '/bg-404.jpg';

const NotFoundPage = () => {
    const navigate = useNavigate();
    const [bgLoaded, setBgLoaded] = useState(false);

    useEffect(() => {
        const img = new Image();
        img.src = BG_URL;
        img.onload = () => setBgLoaded(true);
        img.onerror = () => setBgLoaded(true); // mostra mesmo se a imagem falhar
    }, []);

    return (
        <div className={styles.container}>
            <VBox style={{ opacity: bgLoaded ? 1 : 0, transition: 'opacity 0.15s ease-in' }}>
                <HBox stretch style={{ padding: '0 20px' }}>
                    <span className={styles.code}>404</span>
                    <span className={styles.code}>404</span>
                </HBox>
                <div className={styles.textContent}>
                    <span className={styles.logo}>
                        <img className={styles.logo} src="/logo.png" alt="Logo" height={120} />
                    </span>
                    <h3>Página não encontrada</h3>
                    <Texto>Parece que você saiu da rota! Mas estamos aqui para ajudar.</Texto>
                    <HBox className={styles.actions}>
                        <Botao variant="primary" onClick={() => navigate('/chat')}>
                            Ir para o início
                        </Botao>
                        <Botao variant="outline-secondary" onClick={() => navigate(-1)}>
                            Voltar
                        </Botao>
                    </HBox>
                </div>
            </VBox>
        </div>
    );
};

export default NotFoundPage;
